<template>
    <div class="blog-cat-grid">
        <article class="post" v-for="(note, index) in notes" :key="note._id || note.id">
            <a :href="href(note)" style="display:contents;text-decoration:none;color:inherit;">
                <div class="p-img">
                    <img v-if="thumb(note)" :src="thumb(note)" :alt="note.name" loading="lazy"
                        style="width:100%;height:100%;object-fit:cover;" />
                    <div v-else class="ph"><span class="ph-lbl">{{ note.name }}</span></div>
                </div>
                <div class="p-cat" v-if="category(note)">{{ category(note) }}</div>
                <h3>{{ note.name }}</h3>
                <p>{{ note.blurb }}</p>
                <span class="link-arrow">{{ translations.read_more_button }} <span class="arw">&rarr;</span></span>
            </a>
        </article>
    </div>
</template>

<script>
export default {
    inject: ['translations', 'locale'],

    props: {
        notes: {
            type: Array,
            required: true,
        },
    },

    methods: {
        href(note) {
            return `/${this.locale}/blog/${note.slug}`;
        },

        category(note) {
            return note?.categories?.[0]?.name || null;
        },

        thumb(note) {
            const value = note.thumbnail || note.banner;
            if (value == null) return null;
            if (typeof value === 'object') return value.url;
            if (typeof value === 'string') return value;
            return null;
        }
    }
};
</script>
